import { gql } from '@apollo/client';

export const ALL_HOLIDAYS_QUERY_NAME = 'AllHolidays';
export const ALL_HOLIDAYS = gql`
    query ${ALL_HOLIDAYS_QUERY_NAME} (
        $page: Int, 
        $perPage: Int,
    ) {
        allHolidays (
            page: $page, 
            perPage: $perPage,
        ) {
            availableHolidayYears {
                year
                holidays {
                    id
                    name
                    holidayDate
                }
            }
            holidayList {
                totalCount,
                models {
                    year,
                    holidays {
                        id,
                        name,
                        holidayDate
                   }
                }
            }
        }
    }
`;

export const CREATE_HOLIDAY_YEAR = gql`
    mutation CreateHolidayYear(
        $year: Int!, 
        $holidays: [HolidayInputInput]!, 
        $correlationId: String!
    ) {
        createHolidayYear(
            year: $year, 
            holidays: $holidays, 
            correlationId: $correlationId
        ) {
            year
        }
    }
`;

export const UPDATE_HOLIDAY_YEAR = gql`
    mutation UpdateHolidayYear(
        $year: Int!, 
        $holidays: [HolidayInputInput]!, 
        $correlationId: String!
    ) {
        updateHolidayYear(
            year: $year, 
            holidays: $holidays, 
            correlationId: $correlationId
        ) {
            year
        }
    }
`;

export const ON_HOLIDAY_CHANGED = gql`
    subscription onHolidayChanged {
        holidayChanged {
            correlationId
            action
            model {
                year
            }
        }
    }
`;
